export default class Filters {
  public primaryOptions: any = {
    brands: [],
    price: {},
    mileage: {},
  }

  public carselexy: boolean = false

  public otherOptions: any = []

  constructor(data: any = emptyFilters) {
    this.primaryOptions = {
      brands: data.primaryOptions.brands ? data.primaryOptions.brands : [],
      price: {
        min: data.primaryOptions.price.min ? data.primaryOptions.price.min : 0,
        max: data.primaryOptions.price.max ? data.primaryOptions.price.max : 100000,
      },
      mileage: {
        min: data.primaryOptions.mileage.min ? data.primaryOptions.mileage.min : 0,
        max: data.primaryOptions.mileage.max ? data.primaryOptions.mileage.max : 100000,
      },
    }
    this.carselexy = this.otherOptions = data.otherOptions ? data.otherOptions : []
  }
}

const emptyFilters = {
  primaryOptions: {
    brands: [],
    price: {},
    mileage: {},
  },
  carselexy: false,
  otherOptions: [],
}
